"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectPowerBiReportModal = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var pwc_deals_web_common_1 = require("@pwc/pwc-deals-web-common");

var react_bootstrap_1 = require("react-bootstrap");

var Button_1 = __importDefault(require("../../common/Button"));

var Icon_1 = __importDefault(require("../../common/Icon"));

var Toggle_1 = __importDefault(require("../../common/Toggle"));

var SelectPowerBiReportModal = function (_a) {
  var _b = _a.show,
      show = _b === void 0 ? true : _b,
      _c = _a.onHide,
      onHide = _c === void 0 ? function () {} : _c,
      _d = _a.onBack,
      onBack = _d === void 0 ? function () {} : _d,
      _e = _a.onAdd,
      onAdd = _e === void 0 ? function () {} : _e,
      file = _a.file,
      height = _a.height,
      engagementUrl = _a.engagementUrl,
      createPBILibraryItem = _a.createPBILibraryItem,
      pageTitle = _a.pageTitle,
      powerBiReport = _a.powerBiReport,
      calcContentHeight = _a.calcContentHeight;
  var ref = (0, react_1.useRef)();

  var _f = (0, react_1.useState)(null),
      reportData = _f[0],
      setReportData = _f[1];

  var _g = (0, react_1.useState)(null),
      pageSelected = _g[0],
      setPageSelected = _g[1];

  var _h = (0, react_1.useState)(false),
      allTabsSelected = _h[0],
      setAllTabsToggle = _h[1];

  var _j = (0, react_1.useState)(file),
      elementToAdd = _j[0],
      setElementToAdd = _j[1];

  var _k = (0, react_1.useState)(false),
      isPBIRendered = _k[0],
      setPBIRenderedStatus = _k[1];

  var powerBiItem = (0, react_1.useMemo)(function () {
    return file && __assign(__assign({}, file), {
      data: reportData && pageSelected ? "{\"ReportId\":\"" + reportData.reportId + "\",\"PageName\":\"" + pageSelected.name + "\", \"EmbedUrl\":\"" + reportData.embedUrl + "\", \"EmbedToken\":\"" + reportData.embedToken + "\"}" : file.data,
      pageName: pageSelected ? pageSelected.name : null,
      pageDisplayName: pageSelected ? pageSelected.displayName : null,
      type: allTabsSelected ? pwc_deals_web_common_1.Constants.LIBRARY_ITEM_TYPES.POWER_BI_REPORT.value : pwc_deals_web_common_1.Constants.LIBRARY_ITEM_TYPES.POWER_BI_REPORT_PAGE.value
    });
  }, [file, reportData, pageSelected, allTabsSelected]);
  (0, react_1.useEffect)(function () {
    return setElementToAdd(powerBiItem);
  }, [powerBiItem]);

  var handleTabs = function () {
    var areAllTabsSelected = !allTabsSelected;
    var selectedItem = allTabsSelected ? __assign(__assign({}, file), {
      type: pwc_deals_web_common_1.Constants.LIBRARY_ITEM_TYPES.POWER_BI_REPORT.value
    }) : __assign(__assign({}, powerBiItem), {
      type: pwc_deals_web_common_1.Constants.LIBRARY_ITEM_TYPES.POWER_BI_REPORT_PAGE.value
    });
    setAllTabsToggle(areAllTabsSelected);
    setElementToAdd(selectedItem);
  };

  var reportItem = (0, react_1.useMemo)(function () {
    return file;
  }, [file]);
  return (0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal, __assign({
    ref: ref,
    className: "select-powerbi-modal",
    show: show,
    onHide: onHide,
    centered: true
  }, {
    children: (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "select-powerbi-modal__wrapper",
      style: {
        height: (height || 0) * 0.8
      }
    }, {
      children: [(0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal.Header, __assign({
        closeButton: true
      }, {
        children: (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Modal.Title, {
          children: [(0, jsx_runtime_1.jsxs)(Button_1.default, __assign({
            className: "button-menu",
            type: "button",
            onClick: onBack,
            "data-testid": "back-button"
          }, {
            children: [(0, jsx_runtime_1.jsx)(Icon_1.default, {
              name: "left-chevron",
              width: 14,
              className: "fill icon-orange"
            }, void 0), "Back"]
          }), void 0), pageTitle(title)]
        }, void 0)
      }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
        className: "select-powerbi-modal__content",
        style: {
          height: calcContentHeight(height)
        }
      }, {
        children: height && file && powerBiReport({
          item: reportItem,
          height: height,
          handleReportData: setReportData,
          handlePageSelect: setPageSelected,
          handleRenderStatus: setPBIRenderedStatus,
          showAutoSync: false
        })
      }), void 0), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal.Footer, {
        children: (0, jsx_runtime_1.jsxs)("div", __assign({
          className: "select-powerbi-modal__actions"
        }, {
          children: [(0, jsx_runtime_1.jsx)("div", __assign({
            className: "select-powerbi-modal__actions-link"
          }, {
            children: (0, jsx_runtime_1.jsxs)("p", {
              children: ["Source file link", (0, jsx_runtime_1.jsx)("a", __assign({
                href: engagementUrl + "/reports",
                target: "_blank",
                rel: "noopener noreferrer"
              }, {
                children: file.name
              }), void 0)]
            }, void 0)
          }), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({
            className: "select-powerbi-modal__actions-buttons"
          }, {
            children: [(0, jsx_runtime_1.jsx)("div", __assign({
              className: "select-powerbi-modal__actions-checkbox"
            }, {
              children: (0, jsx_runtime_1.jsx)(Toggle_1.default, __assign({
                checked: allTabsSelected,
                onClick: handleTabs,
                name: "powerbi-select-all",
                dataTestId: "powerbi-modal-select-all-tabs"
              }, {
                children: "Import all tabs"
              }), void 0)
            }), void 0), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({
              className: "btn-large",
              type: "button",
              disabled: !isPBIRendered,
              onClick: function () {
                return __awaiter(void 0, void 0, void 0, function () {
                  var libraryItemId, libraryItemCreated;
                  return __generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        return [4
                        /*yield*/
                        , createPBILibraryItem(elementToAdd)];

                      case 1:
                        libraryItemId = _a.sent();
                        libraryItemCreated = __assign(__assign({}, elementToAdd), {
                          id: libraryItemId
                        });

                        if (allTabsSelected) {
                          libraryItemCreated.pageName = '';
                        }

                        onAdd(libraryItemCreated);
                        return [2
                        /*return*/
                        ];
                    }
                  });
                });
              }
            }, {
              children: "Add page"
            }), void 0)]
          }), void 0)]
        }), void 0)
      }, void 0)]
    }), void 0)
  }), void 0);
};

exports.SelectPowerBiReportModal = SelectPowerBiReportModal;